import apiempresaweb from '@/services/api-recebimentoweb';

export default {
  namespaced: true,

  state: {
    list: [],
    inventario: {},
    quantidadeTotal: 0,
  },

  getters: {
    list: (state) => state.list,
  },
  actions: {
    async find(_, { where, ...params } = {}) {
      const { data } = await apiempresaweb.get('inventario', { params: { ...where, ...params } });
      return data;
    },
    async findDetalhado(_, { idUsuario }) {
      const { data } = await apiempresaweb.get(`inventario/detalhado/${idUsuario}`);
      return data;
    },
    async create(_, body) {
      const { data } = await apiempresaweb.post('inventario', body);
      return data;
    },
    async update({ commit }, body) {
      const { data } = await apiempresaweb.put(`inventario/${body.id}`, body);
      commit('SET_INVENTARIO', body);
      return data;
    },
    async delete(_, body) {
      const { data } = await apiempresaweb.delete(`inventario/${body.id}`, body);
      return data;
    },
  },
  mutations: {
    SET_LIST(state, list) {
      state.list = list ?? [];
    },
    SET_INVENTARIO(state, inventario) {
      state.inventario = { ...state.inventario, ...inventario };
    },
    SET_INVENTARIO_QUANTIDADE(state, quantidade) {
      state.inventario.quantidade = quantidade !== '0' ? quantidade : 0;
    },
    ADD_INVENTARIO_QUANTIDADE(state, quantidade) {
      state.inventario.quantidade = Number(state.inventario.quantidade) + Number(quantidade);
    },
    DELETE_INVENTARIO_QUANTIDADE(state, quantidade) {
      state.inventario.quantidade -= quantidade;
    },
    SET_INVENTARIO_NOMEUSUARIO(state, nome) {
      state.inventario.nomeusuario = nome ?? null;
    },
    CLEAR_INVENTARIO(state) {
      state.inventario = {};
    },
    SET_QUANTIDADETOTAL(state, quantidadeTotal) {
      state.quantidadeTotal = quantidadeTotal ?? 0;
    },
    CLEAR_QUANTIDADETOTAL(state) {
      state.quantidadeTotal = 0;
    },
  },
};
